import React from 'react';

const AdminForm = ({ formData, onFormChange, onSubmit, isEdit = false, isMutating, selectedAdmin, onCancel }) => (
  <form onSubmit={(e) => onSubmit(e, isEdit)} className="space-y-4">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Name *
      </label>
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={onFormChange}
        required
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        placeholder="Enter admin name"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Email *
      </label>
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={onFormChange}
        required
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        placeholder="Enter email address"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Password {isEdit ? '(Leave blank to keep current)' : '*'}
      </label>
      <input
        type="password"
        name="password"
        value={formData.password}
        onChange={onFormChange}
        required={!isEdit}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        placeholder={isEdit ? "Leave blank to keep current password" : "Enter password"}
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Profile Image
      </label>
      <input
        type="file"
        name="image"
        accept="image/*"
        onChange={onFormChange}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
      />
      {isEdit && selectedAdmin?.image && (
        <div className="mt-2">
          <img 
            src={selectedAdmin.image} 
            alt="Current profile" 
            className="h-16 w-16 rounded-full object-cover"
          />
          <p className="text-xs text-gray-500 mt-1">Current profile image</p>
        </div>
      )}
    </div>

    <div className="flex justify-end space-x-3 pt-4">
      <button
        type="button"
        onClick={onCancel}
        className="px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg"
        disabled={isMutating}
      >
        Cancel
      </button>
      <button
        type="submit"
        disabled={isMutating}
        className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isMutating ? (isEdit ? 'Updating...' : 'Creating...') : (isEdit ? 'Update Admin' : 'Create Admin')}
      </button>
    </div>
  </form>
);

export default AdminForm; 